<div class="inner-card flow-root column">
    <div class="filter-form">

        <app-date-period-filter [IsBothDatesRequired]="false" [DateType]="DateFilterType.Common"
        [PeriodFrom]="CommonDateFrom" [PeriodTo]="CommonDateTo"
        (FromDateChanged)="SetDate('commonDateFrom', $event)"
        (ToDateChanged)="SetDate('commonDateTo', $event)">
        </app-date-period-filter>  

        <!-- <mat-form-field class="mr-20 example-full-width date" floatLabel="always"
            *ngIf="!selectionService.selectionPermissions.HasPermisos510">
            <mat-label>Autor</mat-label>
            <input matInput placeholder="Autor" [(ngModel)]="selectionService.loggedDoctorName" [readonly]="true"
                class="disable-txt">
        </mat-form-field> -->

        <!-- <app-autor-filter (AutorChanged)="onChangeAutor('Autor',$event)" (UserChanged)="onChangeAutor('User',$event)"
            (MedicoChanged)="onChangeAutor('Medico',$event)" (CoordinatorChanged)="onChangeAutor('Coordinator',$event)"
            *ngIf="selectionService.selectionPermissions.HasPermisos510">
        </app-autor-filter> -->

        <app-globle-author  *ngIf="selectionService.selectionPermissions.HasPermisos510" [authorFormGroup]="taskManagementService.TaskManagementForm.get('Author')"  [moduleName]="responsibleModuleName"  [authorTypes]="responsibleAuthorTypes" (AutorChanged)="onChangeAutor('Autor',$event)" (UserChanged)="onChangeAutor('User',$event)"
        (MedicoChanged)="onChangeAutor('Medico',$event)" (CoordinatorChanged)="onChangeAutor('Coordinator',$event)">
        </app-globle-author>

        <div fxFlex.gt-sm="20" fxFlexAlign="center" class="double-options">
            <mat-slide-toggle *ngIf="selectionService.selectionPermissions.HasPermisos510" class="m-r-10 m-t-5"
                [(ngModel)]="Historial" (change)="onChange('Historial')">Historial</mat-slide-toggle>
            <mat-checkbox class="prioritari-checkbx" class="m-r-10 m-t-5" [(ngModel)]="isPrioritarias" (change)="onChange('isPrioritarias')">
                Prioritarias</mat-checkbox>

                <mat-checkbox [(ngModel)]="EmpresaSelec" (change)="onChange('EmpresaSelec')">Solo empresa seleccionada
                </mat-checkbox>
        </div>

        <mat-form-field>
            <mat-label>Orden</mat-label>
            <mat-select class="full-width-multi-select" [(ngModel)]="selectionService.taskSelectionModal.Orden">
                <mat-option *ngFor="let orden of OrdenList$" [value]="orden.value">{{orden.text}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>